import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from 'react-auth-kit';
import { ReactElement } from 'react';
import config from '../const/config';

export interface IProps {
  children: ReactElement;
}

const PublicRoute: React.FC<IProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const dataGroup: any = localStorage.getItem('group-selected');

  if (isAuthenticated() && dataGroup) {
    const company = JSON.parse(dataGroup).state?.company;
    if (!company || !company.companyId) {
      return children;
    }
    return <Navigate to={config.defaultPath || '/home'} replace />;
  }

  return children;
};

export default PublicRoute;
